const PARAMETERS = [
  { key: 'battery_voltage', series: 'batteryVoltageData', min: 'minBatteryVoltage', max: 'maxBatteryVoltage' },
  { key: 'coulomb_count', series: 'coulombCountData', min: 'minCoulombCount', max: 'maxCoulombCount' },
  { key: 'wifi_rssi', series: 'wifiRSSILevelData', min: 'minWifiRSSILevel', max: 'maxWifiRSSILevel' },
  {
    key: 'measurement_cycle_time',
    series: 'measurementCycleTimeData',
    min: 'minMeasurementCycleTime',
    max: 'maxMeasurementCycleTime'
  },
  { key: 'wifi_connect_time', series: 'wifiConnectTimeData', min: 'minWifiConnectTime', max: 'maxWifiConnectTime' },
  { key: 'data_exchange_time', series: 'dataExchangeTimeData', min: 'minDataExchangeTime', max: 'maxDataExchangeTime' }
];

const isPlottable = value => typeof value === 'number' && Number.isFinite(value);

// Bounds for a parameter with nothing plottable stay at the identities for min/max rather than
// null, so the caller's clamping (`min > 2.2 ? 2.2 : min - 0.2`) still falls back to its default
// instead of doing arithmetic on null. Those charts get skipped anyway, but the axis maths must
// not depend on that.
const NO_MIN = Infinity;
const NO_MAX = -Infinity;

const emptyResult = () => {
  const result = {};
  PARAMETERS.forEach(({ series, min, max }) => {
    result[series] = [];
    result[min] = NO_MIN;
    result[max] = NO_MAX;
  });
  return result;
};

/**
 * Turns the /info-logs payload into one [timestamp, value] series per device parameter.
 *
 * Unreported parameters still come back on every log with a null value. Google Charts types
 * an all-null column as `string` and the LineChart then refuses to draw it
 * ("Data column(s) for axis #0 cannot be of type string"), so a series with nothing plottable
 * is dropped entirely and the caller skips that chart.
 */
export function splitDeviceInfoLogs(data) {
  if (!data || !data.data) return emptyResult();

  const series = {};
  const bounds = {};
  PARAMETERS.forEach(({ key }) => {
    series[key] = [];
    bounds[key] = { min: Infinity, max: -Infinity, hasValue: false };
  });

  data.data.forEach((itemArray) => {
    itemArray.forEach((item) => {
      const timestamp = new Date(item.timestamp);

      PARAMETERS.forEach(({ key }) => {
        const value = item[key];
        if (value === undefined) return;

        if (!isPlottable(value)) {
          // Keep the reading as a gap so the line breaks where the device went quiet.
          series[key].push([timestamp, null]);
          return;
        }

        series[key].push([timestamp, value]);
        bounds[key].hasValue = true;
        bounds[key].min = Math.min(bounds[key].min, value);
        bounds[key].max = Math.max(bounds[key].max, value);
      });
    });
  });

  const result = {};
  PARAMETERS.forEach(({ key, series: seriesName, min, max }) => {
    if (!bounds[key].hasValue) {
      result[seriesName] = [];
      result[min] = NO_MIN;
      result[max] = NO_MAX;
      return;
    }
    result[seriesName] = series[key];
    result[min] = bounds[key].min;
    result[max] = bounds[key].max;
  });

  return result;
}

export default splitDeviceInfoLogs;
